import { useEffect } from 'react';
import { useFormik } from 'formik';
import _ from 'lodash';
import {
  EmploymentFormikType,
  employmentValidation,
  employmentInitialValues,
  employmentOnSubmit,
} from 'views/utils/accountEstablish';
import { AccountInfoUpdateRequestParam, useAccountInfoUpdateStore } from './useUpdatePage';
import { EstablishCheckProps } from 'views/components/atoms/establishes/check';

export const useEmploymentUpdate = () => {
  const { param, add } = useAccountInfoUpdateStore();
  const initialValues = employmentInitialValues(param);
  const onSubmit = employmentOnSubmit<AccountInfoUpdateRequestParam>(param, add);

  const formik: EmploymentFormikType = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: employmentValidation,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit,
  });

  const isNoWorkplaceButtonProps: EstablishCheckProps = {
    name: 'isNoWorkplace',
    text: 'なし',
    isChecked: formik.values.isNoWorkplace,
    setIsChecked: () => {
      formik.setFieldValue('workplace', '');
      formik.setFieldValue('isNoWorkplace', !formik.values.isNoWorkplace);
    },
  };

  const isNoDepartmentButtonProps: EstablishCheckProps = {
    name: 'isNoDepartment',
    text: 'なし',
    isChecked: formik.values.isNoDepartment,
    setIsChecked: () => {
      formik.setFieldValue('department', '');
      formik.setFieldValue('isNoDepartment', !formik.values.isNoDepartment);
    },
  };

  const isNoPostButttonProps: EstablishCheckProps = {
    name: 'isNoPost',
    text: 'なし',
    isChecked: formik.values.isNoPost,
    setIsChecked: () => {
      formik.setFieldValue('post', '');
      formik.setFieldValue('isNoPost', !formik.values.isNoPost);
    },
  };

  const isNoWorkPhoneNumberButtonProps: EstablishCheckProps = {
    name: 'isNoWorkPhoneNumber',
    text: 'なし',
    isChecked: formik.values.isNoWorkPhoneNumber,
    setIsChecked: () => {
      formik.setFieldValue('workPhoneNumber', '');
      formik.setFieldValue('isNoWorkPhoneNumber', !formik.values.isNoWorkPhoneNumber);
    },
  };

  return {
    formik,
    checkButtonProps: {
      isNoWorkplaceButtonProps,
      isNoDepartmentButtonProps,
      isNoPostButttonProps,
      isNoWorkPhoneNumberButtonProps,
    },
    isWorkPhoneNumberMask: true,
  };
};
